'use client';

import { vars } from 'nativewind';
import { DARK_COLORS, LIGHT_COLORS } from '@/constants/colors';

function formatCssVariables(themeColors: typeof LIGHT_COLORS | typeof DARK_COLORS) {
return Object.entries(themeColors).reduce((accumulatedCssVariables, [semanticColorKey, semanticColorValues]) => {
  const currentCssVariables = Object.entries(semanticColorValues).reduce((colorVariables, [semanticValueKey, semanticColorValue]) => {
    return {...colorVariables, [`--color-${semanticColorKey}-${semanticValueKey}`]: semanticColorValue}
  }, {});

  return {...accumulatedCssVariables, ...currentCssVariables};
}, {});
}

export const config = {
  light: vars(formatCssVariables(LIGHT_COLORS)),
  dark: vars(formatCssVariables(DARK_COLORS)),
};
